<template>
  <el-dialog
    title="Add investors"
    :visible.sync="visible"
    width="80%"
    :close-on-click-modal="false"
  >
    <el-container>
      <el-main v-loading="isProcessing">
        <el-form>
          <el-form-item label="E-mail">
            <el-input
              v-model="form.emails"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 20 }"
              @keydown.enter.native="onEnter"
            />
            <p v-show="showError" class="text-xs text-danger">
              Wrong email address found - please make sure all emails are
              correct.
            </p>
            <p class="text-xs text-muted">
              You may put multiple emails separated with new lines or spaces.
            </p>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>

    <el-footer>
      <div class="dialog-footer">
        <el-button
          :disabled="emails.length === 0"
          type="primary"
          @click="add()"
        >
          Add
        </el-button>
      </div>
    </el-footer>
  </el-dialog>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,
      form: { emails: '' },
      showError: false,
      isProcessing: false,
    }
  },
  computed: {
    emails() {
      return this.form.emails.split(/\s+/).filter((e) => e)
    },
  },
  methods: {
    open() {
      this.visible = true
      this.form.emails = ''
    },

    async add() {
      if (await this.submit()) {
        this.$emit('add')
        this.visible = false
      }
    },
    async submit() {
      this.isProcessing = true
      const emails = this.form.emails.split(/\s+/).filter((e) => e)
      try {
        await this.$store.dispatch('eventDetails/addUsers', { emails })
        this.showError = false
      } catch (e) {
        this.showError = true
        return false
      } finally {
        this.isProcessing = false
      }
      return true
    },

    onEnter(event) {
      if (event.metaKey || event.ctrlKey) {
        this.add()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  height: 100px;
}
</style>
